import { AppDownload, AppDownloadEntities } from '../app-download.model';
import { AppDownloadActions, AppDownloadActionTypes } from '../actions/app-download.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: AppDownloadEntities;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: { AppDownloadNode: [], start_date: '', end_date: '' }
};

export function reducer(
  state = initialState,
  action: AppDownloadActions
): State {
  switch (action.type) {
    case AppDownloadActionTypes.GetAppDownloads: {
      return {...state, Loaded: false, Loading: true};
    }

    case AppDownloadActionTypes.LoadAppDownloads: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case AppDownloadActionTypes.UpdateAppDownloads: {
      return {...state, Loaded: false, Loading: true};
    }


    default: {
      return state;
    }
  }
}

